import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//auth
import { AuthGuard } from './services/auth.guard';
//pages
import { UtamaComponent } from './pages/utama/utama.component';

//pages - pembayar cukai
import { PenerimaanPelantikanPermohonanOnlineComponent } from './pages/pembayar-cukai/penerimaan-pelantikan-permohonan-online/penerimaan-pelantikan-permohonan-online.component';
import { ButiranPenerimaanPelantikanPermohonanOnlineComponent } from './pages/pembayar-cukai/penerimaan-pelantikan-permohonan-online/butiran-penerimaan-pelantikan-permohonan-online/butiran-penerimaan-pelantikan-permohonan-online.component';
import { EBorangComponent } from './pages/pembayar-cukai/e-borang/e-borang.component';
import { StatusEBorangComponent } from './pages/pembayar-cukai/status-e-borang/status-e-borang.component';

//pages - integrasi
import { ProfilFirmaComponent } from './pages/integrasi/e-bas/profil-firma/profil-firma.component';
import { CetakDrafComponent } from './pages/integrasi/e-bas/cetak-draf/cetak-draf.component';
import { PenghantaranEBorangComponent } from './pages/integrasi/e-bas/penghantaran-e-borang/penghantaran-e-borang.component';
// import { MitrsComponent } from './pages/integrasi/mitrs/mitrs.component';
import { EWhtComponent } from './pages/integrasi/e-wht/e-wht.component';
import { ECkhtComponent } from './pages/integrasi/e-ckht/e-ckht.component';
import { BorangBerulangComponent } from './pages/integrasi/borang-berulang/borang-berulang.component';
import { Mitrs2Component } from './pages/integrasi/mitrs2/mitrs2.component';
import { ESpcComponent } from './pages/integrasi/e-spc/e-spc.component';
import { EEotComponent } from './pages/integrasi/e-eot/e-eot.component';

//pages - penyenggaraan
import { DaftarKemaskiniComponent } from './pages/penyenggaraan/daftar-kemaskini/daftar-kemaskini.component';
import { ButiranDaftarKemaskiniComponent } from './pages/penyenggaraan/daftar-kemaskini/butiran-daftar-kemaskini/butiran-daftar-kemaskini.component';
import { CarianHubunganComponent } from './pages/penyenggaraan/carian-hubungan/carian-hubungan.component';
import { AgihanHubunganComponent } from './pages/penyenggaraan/agihan-hubungan/agihan-hubungan.component';
import { LogAuditComponent } from './pages/penyenggaraan/log-audit/log-audit.component';
import { AgihEBorangEjenCukaiComponent } from './pages/penyenggaraan/agih-e-borang-ejen-cukai/agih-e-borang-ejen-cukai.component';


//pages - bantuan sistem
import { BantuanEdtsComponent } from './pages/bantuan-sistem/bantuan-edts/bantuan-edts.component';
import { OauthCallbackComponent } from './pages/oauth-callback/oauth-callback.component';


//pages - CP8D
//import { Cp8dComponent } from './pages/cp8d/cp8d.component';

const routes: Routes = [

  //pages
  {
    path: '', component: UtamaComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201','0202','0203','0204'] }
  },
  {
    path: 'utama', component: UtamaComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201', '0202', '0203', '0204'] }
  },

  {
    path: 'OauthCallback', component: OauthCallbackComponent,
    //canActivate: [AuthGuard],
    //data: { expectedRoles: ['0201', '0202', '0203', '0204'] }
  },

    //CP8D
  //{
  //  path: 'cp8d', component: Cp8dComponent,
  //  canActivate: [AuthGuard],
  //  data: { expectedRoles: ['0201', '0202', '0203', '0204'] }
  //},

  //pembayar cukai
  {
    path: 'penerimaan-pelantikan-permohonan-online', component: PenerimaanPelantikanPermohonanOnlineComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0204','0201'] }
  },
  {
    path: 'butiran-penerimaan-pelantikan-online', component: ButiranPenerimaanPelantikanPermohonanOnlineComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0204','0201'] }
  },
  {
    path: 'e-borang', component: EBorangComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201', '0202', '0203', '0204'] }
  },
  {
    path: 'status-e-borang', component: StatusEBorangComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201', '0202', '0203', '0204'] }
  },

  //integrasi
  {
    path: 'profil-firma', component: ProfilFirmaComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201','0202', '0203', '0204'] }
  },
  {
    path: 'cetak-draf', component: CetakDrafComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },
  {
    path: 'penghantaran-e-borang', component: PenghantaranEBorangComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },
  // {
  //   path: 'mitrs', component: MitrsComponent,
  //   canActivate: [AuthGuard],
  //   data: { expectedRoles: ['0202', '0203', '0204'] }
  // },
  {
    path: 'e-wht', component: EWhtComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },
  {
    path: 'e-ckht', component: ECkhtComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },
  {
    path: 'e-ckm-cp22', component: BorangBerulangComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },
  {
    path: 'mitrs', component: Mitrs2Component,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },
  {
    path: 'e-spc', component: ESpcComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },

  {
    path: 'e-eot', component: EEotComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0202', '0203', '0204'] }
  },

  //penyenggaraan
  {
    path: 'daftar-kemaskini', component: DaftarKemaskiniComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201', '0204'] }
  },
  {
    path: 'butiran-daftar-kemaskini', component: ButiranDaftarKemaskiniComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201'] }
  },
  {
    path: 'carian-hubungan', component: CarianHubunganComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201'] }
  },
  {
    path: 'agihan-hubungan', component: AgihanHubunganComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201'] }
  },
  {
    path: 'log-audit', component: LogAuditComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201'] }
  },
  {
    path: 'agih-e-borang-ejen-cukai', component: AgihEBorangEjenCukaiComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201'] }
  },


  //pages - bantuan sistem
  {
    path: 'bantuan-edts', component: BantuanEdtsComponent,
    canActivate: [AuthGuard],
    data: { expectedRoles: ['0201','0202','0203','0204'] }
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
